export function clientCoordsToSvgCoords(
    svg: SVGSVGElement,
    clientX: number,
    clientY: number
): { x: number; y: number } {
    const point = svg.createSVGPoint();

    point.x = clientX;
    point.y = clientY;

    return point.matrixTransform(svg.getScreenCTM().inverse());
}
